import {
    getSubscriptions,
    deleteSubscription,
    createSubscription,
    updateSubscription
} from '../../../services/SubscriptionService';
import {
    CONFIRMED_GET_SUBSCRIPTIONS
} from './SubscriptionTypes';

export function getSubscriptionsAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
        getSubscriptions(currentPage, pageSize, searchTerm, filterQuery).then((response) => {
            dispatch(confirmedGetSubscriptionsAction(response.data.data));
        });
    };
}

export function confirmedGetSubscriptionsAction(data) {
    return {
        type: CONFIRMED_GET_SUBSCRIPTIONS,
        payload: data,
    };
}

export function deleteSubscriptionAction(id, history) {
    return (dispatch, getState) => {
        return deleteSubscription(id).then((response) => {
            return response;
        });
    };
}

export function createSubscriptionAction(data) {
    return () => {
        return createSubscription(data).then((response) => {
            return response;
        });
    };
}

export function updateSubscriptionAction(id, data) {
    return () => {
        return updateSubscription(id, data).then((response) => {
            return response;
        });
    };
}